import { useRef, useEffect } from 'react';

const usePrevious = <T>(previousValue: T): T | undefined => {
  const previousRef = useRef<T>();

  useEffect(() => {
    previousRef.current = previousValue;
  }, [previousRef, previousValue]);

  return previousRef.current;
};

export default usePrevious;
